export const DEFAULT_BOT_AVATAR =
  "https://siteglue-cdn.com/images/_17675382776175_ee303136.gif";

export const DEFAULT_POWERED_BY_LOGO =
  "https://siteglue-cdn.com/images/_17675767745826_a88944fb.png";

export const DEFAULT_HUMAN_AVATAR =
  "https://agencychatbot.app/assets/themes/ample/css/icons/base-Image.svg";

const isBrokenWidgetImageUrl = (url) => {
  const value = String(url || "").trim();
  if (!value || value === "undefined" || value === "null") {
    return true;
  }

  const brokenPatterns = [
    "s3.amazonaws.com",
    "/uploads/images/default-logo.png",
    "getsiteglue.com/wp-content",
    "siteglue.ai/wp-content",
    "round-profile-pic",
  ];

  return (
    brokenPatterns.some((pattern) => value.includes(pattern)) ||
    (value.includes("/uploads/images/") &&
      !value.includes("siteglue-cdn.com") &&
      !value.includes("r2.dev"))
  );
};

export const resolveBotAvatar = (url) =>
  isBrokenWidgetImageUrl(url) ? DEFAULT_BOT_AVATAR : String(url).trim();

export const resolveHumanAvatar = (url) =>
  isBrokenWidgetImageUrl(url) ? DEFAULT_HUMAN_AVATAR : String(url).trim();

export const handleBotAvatarError = (event) => {
  if (event && event.target) {
    event.target.onerror = null;
    event.target.src = DEFAULT_BOT_AVATAR;
  }
};

export const handleHumanAvatarError = (event) => {
  if (event && event.target) {
    event.target.onerror = null;
    event.target.src = DEFAULT_HUMAN_AVATAR;
  }
};
